<template>
    <div
        class="zl-progress"
        :class="
            status > value ? 'zl-finished' : status === value ? 'zl-active' : ''
        "
    >
        <h3 v-if="date">{{ date }}</h3>
        <div class="zl-box">
            <h4>{{ title }}</h4>
            <template v-if="status >= value">
                <div v-for="item in _fields" :key="item.label" class="zl-box-fields">
                    <span>{{ item.label }}：</span>
                    <span>{{ item.value }}</span>
                </div>
            </template>
            <div v-if="status >= value" class="zl-box-action">
                <span
                    v-for="item in actions"
                    :key="item.value"
                    @click="handleClick(item)"
                >{{ item.label }}</span>
            </div>
            <div style="clear: both" />
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ZlProgress',
        props: {
            title: {
                type: String,
                default: '',
            },
            value: {
                type: Number,
                default: 1,
            },
            status: {
                type: Number,
                default: 0,
            },
            actions: {
                type: Array,
                default: () => [],
            },
            fields: {
                type: Array,
                default: () => [],
            },
            date: {
                type: String,
                default: '',
            },
        },
        computed: {
            _fields() {
                return this.fields || []
            },
        },
        methods: {
            handleClick(item) {
                this.$emit('handleClick', item)
            },
        },
    }
</script>
<style lang="scss">
.zl-progress {
  margin-bottom: 20px;
  position: relative;
  &::after,
  &::before {
    content: "";
    position: absolute;
    left: -20px;
  }
  &::before {
    width: 6px;
    height: 6px;
    background: #8798b2;
    border-radius: 6px;
    transform: translateX(-50%);
  }
  &::after {
    top: 6px;
    bottom: -36px;
    border-left: 1px solid #b0bed4;
  }

  &.zl-finished {
    &::after {
      top: 14px;
      bottom: -20px;
      border-left: 1px dashed #02B38A;
    }
    &::before {
      width: 14px;
      height: 14px;
      background: url("../assets/icon/进度详情-已完成@2x.png") center no-repeat;
      background-size: contain;
    }
  }

  &.zl-active {
    &::before {
      width: 16px;
      height: 16px;
      font-size: 50px;
      line-height: 16px;
      text-align: center;
      box-shadow: 0px 3px 5px -1px #bac2d2;
      border-radius: 16px;
      background: #02B38A;
      background-clip: content-box;
      padding: 3px;
      box-sizing: border-box;
    }
    &::after {
      top: 16px;
      bottom: -20px;
      border-left: 1px solid #b0bed4;
    }
  }

  h3 {
    font-size: 12px;
    color: #8798b2;
    line-height: 20px;
    margin-bottom: 6px;
    padding-left: 16px;
    background: url("../assets/icon/time.svg") left center no-repeat;
    background-size: 1em 100%;
  }
}
div.zl-box {
  // height: 138px;
  background: rgba(231, 235, 242, 0.45);
  border-radius: 8px;
  border: 1px solid rgba(231, 235, 242, 0.45);
  padding: 16px 0 16px 16px;
  &-fields {
    font-size: 12px;
    margin-top: 5px !important;
  }
  &-action {
    span {
      margin-right: 10px;
      font-size: 13px;
      color: #02B38A;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      list-style: none;
      word-break: keep-all;
      float: left;
    }
  }
  h4 {
    font-size: 16px;
    color: #262626;
    line-height: 24px;
    margin-bottom: 8px;
  }
  p {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 20px;
  }
  div {
    margin-top: 12px;
    font-size: 12px;
    line-height: 22px;
    a {
      color: #02B38A;
    }
    .line {
      display: inline-block;
      height: 1em;
      width: 1px;
      background: #02B38A;
      margin: 0 6px;
      vertical-align: middle;
    }
  }
}
</style>
